export type UserSidebarIcon =
    | {
        type: "bootstrap";
        className: string;
    }
    | {
        type: "lucide";
        name:
        | "dashboard"
        | "account"
        | "network"
        | "address"
        | "portfolio"
        | "orders"
        | "food"
        | "stuff"
        | "referral"
        | "earnings"
        | "wallet"
        | "withdrawal"
        | "chat"
        | "testimonial"
        | "games";
    };

export type UserSidebarChildItem = {
    id: string;
    label: string;
    route: string;
    searchTerms?: string[];
};

export type UserSidebarItem = {
    id: string;
    label: string;
    route?: string;
    icon: UserSidebarIcon;
    children?: UserSidebarChildItem[];
    searchTerms?: string[];
};

export const USER_SIDEBAR_ITEMS: UserSidebarItem[] = [
    {
        id: "dashboard",
        label: "Dashboard",
        route: "/Dashboard",
        icon: {
            type: "lucide",
            name: "dashboard",
        },
        searchTerms: [
            "home",
            "overview",
            "dashboard",
            "main",
        ],
    },

    {
        id: "my-account",
        label: "My Account",
        icon: {
            type: "lucide",
            name: "account",
        },
        searchTerms: [
            "account",
            "profile",
            "personal",
            "kyc",
            "password",
            "security",
        ],
        children: [
            {
                id: "personal-information",
                label: "Personal Information",
                route: "/PersonalDetails",
                searchTerms: [
                    "profile",
                    "personal details",
                    "name",
                    "email",
                    "phone",
                ],
            },
            {
                id: "kyc",
                label: "KYC",
                route: "/Kyc",
                searchTerms: [
                    "verification",
                    "identity",
                    "pan",
                    "aadhaar",
                    "kyc document",
                ],
            },
            {
                id: "change-password",
                label: "Change Password",
                route: "/ChangePassword",
                searchTerms: [
                    "password",
                    "login password",
                    "security",
                    "reset password",
                ],
            },
            {
                id: "change-transaction-password",
                label: "Change Txn Password",
                route: "/ChangeTxnPassword",
                searchTerms: [
                    "transaction pin",
                    "txn password",
                    "payment password",
                    "transfer pin",
                ],
            },
            {
                id: "deactivate-account",
                label: "De-Activate Account",
                route: "/DeActiveAccount",
                searchTerms: [
                    "deactivate",
                    "pause account",
                    "suspend",
                ],
            },
            {
                id: "closure-account",
                label: "Closure Account",
                route: "/CloseAccount",
                searchTerms: [
                    "close account",
                    "delete account",
                    "closure",
                    "terminate",
                ],
            },
        ],
    },

    {
        id: "my-network",
        label: "My Network",
        icon: {
            type: "lucide",
            name: "network",
        },
        searchTerms: [
            "network",
            "team",
            "referrals",
            "invitations",
            "community",
            "downline",
        ],
        children: [
            {
                id: "my-invitations",
                label: "My Invitations",
                route: "/Referralcommunity",
                searchTerms: [
                    "invitations",
                    "referral community",
                    "invited members",
                ],
            },
            {
                id: "partner-growth",
                label: "Partner Growth",
                route: "/PartnerGrowth",
                searchTerms: [
                    "partner",
                    "growth",
                    "partner network",
                ],
            },
            {
                id: "salar-samriddhi",
                label: "Salar Samriddhi",
                route: "/InfinityCommunity",
                searchTerms: [
                    "samriddhi",
                    "infinity community",
                    "infinity",
                    "levels",
                ],
            },
        ],
    },

    {
        id: "manage-address",
        label: "Manage Address",
        route: "/ManageAddress",
        icon: {
            type: "lucide",
            name: "address",
        },
        searchTerms: [
            "address",
            "delivery address",
            "shipping address",
            "location",
        ],
    },

    {
        id: "my-portfolio",
        label: "My Portfolio",
        route: "/Portfolio",
        icon: {
            type: "lucide",
            name: "portfolio",
        },
        searchTerms: [
            "portfolio",
            "investments",
            "assets",
            "gallery",
        ],
    },

    {
        id: "orders-list",
        label: "Orders List",
        route: "/MyOrders",
        icon: {
            type: "lucide",
            name: "orders",
        },
        searchTerms: [
            "orders",
            "purchase",
            "my orders",
            "order history",
            "tracking",
        ],
    },

    {
        id: "food-orders-list",
        label: "Food Orders List",
        route: "/FoodOrderList",
        icon: {
            type: "lucide",
            name: "food",
        },
        searchTerms: [
            "food",
            "restaurant",
            "food orders",
            "meals",
            "dining",
        ],
    },

    {
        id: "my-stuff",
        label: "My Stuff",
        icon: {
            type: "lucide",
            name: "stuff",
        },
        searchTerms: [
            "stuff",
            "vouchers",
            "gifts",
            "stores",
            "offers",
            "subscriptions",
            "lucky draw",
        ],
        children: [
            {
                id: "salar-shopping-voucher",
                label: "Salar Shopping Voucher",
                route: "/SalarShopVoucher",
                searchTerms: [
                    "voucher",
                    "shopping voucher",
                    "coupon voucher",
                    "discount voucher",
                ],
            },
            {
                id: "gifts",
                label: "Gifts",
                route: "/Gifts",
                searchTerms: [
                    "gifts",
                    "rewards",
                    "presents",
                ],
            },
            {
                id: "liked-stores",
                label: "Liked Stores",
                route: "/LikedStores",
                searchTerms: [
                    "liked",
                    "favorite stores",
                    "saved shops",
                ],
            },
            {
                id: "review-stores",
                label: "Review Stores",
                route: "/ReviewStores",
                searchTerms: [
                    "review",
                    "feedback",
                    "store reviews",
                    "rating",
                ],
            },
            {
                id: "offers",
                label: "Offers",
                route: "/Offers",
                searchTerms: [
                    "offers",
                    "deals",
                    "promotions",
                    "discounts",
                ],
            },
            {
                id: "subscriptions",
                label: "Subscriptions",
                route: "/Subscriptions",
                searchTerms: [
                    "subscriptions",
                    "plans",
                    "membership",
                ],
            },
            {
                id: "lucky-draw",
                label: "Lucky Draw",
                route: "/LuckyDraw",
                searchTerms: [
                    "lucky draw",
                    "lottery",
                    "contest",
                    "spin",
                ],
            },
        ],
    },

    {
        id: "referral-incentives",
        label: "Referral Incentives",
        icon: {
            type: "lucide",
            name: "referral",
        },
        searchTerms: [
            "referral",
            "incentives",
            "sponsor",
            "loyalty",
            "commission",
        ],
        children: [
            {
                id: "i-referral-incentives",
                label: "I.Referral Incentives",
                route: "/ReferralIncentive",
                searchTerms: [
                    "referral incentives",
                    "i referral",
                    "invite incentives",
                ],
            },
            {
                id: "loyalty-referral-incentives",
                label: "Loyalty Referral Incentives",
                route: "/LoyaltyRefIncentive",
                searchTerms: [
                    "loyalty referral",
                    "loyalty incentive",
                    "retention",
                ],
            },
            {
                id: "sponsor-commission",
                label: "Sponsor Commission",
                route: "/SponsorCommission",
                searchTerms: [
                    "sponsor",
                    "sponsor commission",
                    "direct sponsor",
                ],
            },
        ],
    },

    {
        id: "my-earnings",
        label: "My Earnings",
        icon: {
            type: "lucide",
            name: "earnings",
        },
        searchTerms: [
            "earnings",
            "income",
            "incentives",
            "commission",
            "salar flow",
            "pearls",
            "milestones",
        ],
        children: [
            {
                id: "salar-flow-incentives",
                label: "Salar Flow Incentives",
                route: "/ReferralCommission",
                searchTerms: [
                    "salar flow",
                    "flow incentives",
                    "referral commission",
                ],
            },
            {
                id: "salar-samriddhi-incentives",
                label: "Salar Samriddhi Incentives",
                route: "/PrtCommisson",
                searchTerms: [
                    "samriddhi incentives",
                    "prt commission",
                    "infinity commission",
                ],
            },
            {
                id: "community-growth-incentives",
                label: "Comm Growth Incentives",
                route: "/MrcCommissons",
                searchTerms: [
                    "community growth",
                    "mrc commission",
                    "group growth",
                ],
            },
            {
                id: "partner-growth-incentives",
                label: "Partner Growth Incentives",
                route: "/PartnerGrowthIncentives",
                searchTerms: [
                    "partner growth",
                    "growth incentives",
                    "partner rewards",
                ],
            },
            {
                id: "salar-unity",
                label: "Salar Unity",
                route: "/SalarUnity",
                searchTerms: [
                    "unity",
                    "salar unity",
                    "pool",
                ],
            },
            {
                id: "salar-pearls",
                label: "Salar Pearls",
                route: "/SalarCoins",
                searchTerms: [
                    "salar pearls",
                    "pearls",
                    "coins",
                    "points",
                ],
            },
            {
                id: "milestone-incentives",
                label: "Milestone Incentives",
                route: "/ShoppingAmount",
                searchTerms: [
                    "milestone",
                    "shopping amount",
                    "targets",
                ],
            },
            {
                id: "daily-incentives-list",
                label: "Daily Incentives List",
                route: "/DailyCommissons",
                searchTerms: [
                    "daily",
                    "daily commission",
                    "daily incentives",
                ],
            },
        ],
    },

    {
        id: "my-wallet",
        label: "My Wallet",
        icon: {
            type: "lucide",
            name: "wallet",
        },
        searchTerms: [
            "wallet",
            "balance",
            "funds",
            "transfer",
            "credit",
            "debit",
            "pay",
        ],
        children: [
            {
                id: "salar-pay",
                label: "Salar Pay",
                route: "/SalarPay",
                searchTerms: [
                    "salar pay",
                    "payment",
                    "pay now",
                ],
            },
            {
                id: "salar-wallet",
                label: "Salar Wallet",
                route: "/salar-wallet",
                searchTerms: [
                    "salar wallet",
                    "wallet",
                    "balance",
                    "funds",
                ],
            },
            {
                id: "fund-transfer",
                label: "Fund Transfer",
                route: "/FundTransfer",
                searchTerms: [
                    "fund transfer",
                    "send money",
                    "transfer funds",
                ],
            },
            {
                id: "credit-debit",
                label: "Credit / Debit",
                route: "/CreditDebit",
                searchTerms: [
                    "credit",
                    "debit",
                    "ledger",
                    "transactions",
                ],
            },
            {
                id: "received-funds",
                label: "Received Funds",
                route: "/RecievedFunds",
                searchTerms: [
                    "received",
                    "incoming funds",
                    "received money",
                ],
            },
            {
                id: "fund-transfer-history",
                label: "Fund Transfer History",
                route: "/FundTransferHistory",
                searchTerms: [
                    "transfer history",
                    "fund history",
                    "sent funds",
                ],
            },
        ],
    },

    {
        id: "withdrawal",
        label: "Withdrawal",
        icon: {
            type: "lucide",
            name: "withdrawal",
        },
        searchTerms: [
            "withdrawal",
            "payout",
            "bank",
            "tds",
            "tax",
            "bav",
        ],
        children: [
            {
                id: "withdrawal-list",
                label: "Withdrawals List",
                route: "/WithdrawlHistory",
                searchTerms: [
                    "withdrawal list",
                    "withdrawal history",
                    "withdrawals",
                ],
            },
            {
                id: "withdrawal-request",
                label: "Withdrawal Request",
                route: "/WithdrawlRequest",
                searchTerms: [
                    "request withdrawal",
                    "cash out",
                    "withdraw money",
                ],
            },
            {
                id: "payout-report",
                label: "Payout Report",
                route: "/PayoutReport",
                searchTerms: [
                    "payout",
                    "report",
                    "settlements",
                ],
            },
            {
                id: "tax-tds",
                label: "Tax - TDS",
                route: "/Tax",
                searchTerms: [
                    "tax",
                    "tds",
                    "deductions",
                    "tax report",
                ],
            },
            {
                id: "bav",
                label: "BAV (Bank Verification)",
                route: "/BankAccVerification",
                searchTerms: [
                    "bav",
                    "bank account verification",
                    "bank details",
                    "ifsc",
                ],
            },
        ],
    },

    {
        id: "chat-list",
        label: "Chat List",
        route: "/Tickets",
        icon: {
            type: "lucide",
            name: "chat",
        },
        searchTerms: [
            "chat",
            "tickets",
            "support",
            "help desk",
            "customer care",
        ],
    },

    {
        id: "testimonials",
        label: "Testimonials",
        route: "/UserTestimonials",
        icon: {
            type: "lucide",
            name: "testimonial",
        },
        searchTerms: [
            "testimonials",
            "feedback",
            "reviews",
            "experience",
        ],
    },

    {
        id: "games",
        label: "Games",
        route: "/Games",
        icon: {
            type: "lucide",
            name: "games",
        },
        searchTerms: [
            "games",
            "play",
            "entertainment",
            "rewards",
        ],
    },
];
